// Who is asking, as the logs and the metrics describe a browser: the Blazor app's metricsInterop.js.

const DEVICE_ID_KEY = 'lify_device_id';
const SESSION_TIMEOUT_MS = 30 * 60 * 1000;

let deviceId: string | null = null;
let sessionId: string | null = null;
let lastActivity = 0;

/** One per browser, kept in localStorage under the key the Blazor app used, so a browser keeps its id. */
export function getDeviceId(): string {
    if (deviceId) return deviceId;

    try {
        deviceId = localStorage.getItem(DEVICE_ID_KEY);

        if (!deviceId) {
            deviceId = 'web_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10);
            localStorage.setItem(DEVICE_ID_KEY, deviceId);
        }
    } catch {
        deviceId = deviceId || 'web_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10);
    }

    return deviceId;
}

/** A new session after half an hour without anything to report. */
export function getSessionId(): string {
    const now = Date.now();

    if (!sessionId || now - lastActivity > SESSION_TIMEOUT_MS) {
        sessionId = Array.from(crypto.getRandomValues(new Uint8Array(16)), b => b.toString(16).padStart(2, '0')).join('');
    }

    lastActivity = now;

    return sessionId;
}

export function getDeviceInfo() {
    return {
        userAgent: navigator.userAgent,
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        language: navigator.language,
        screenWidth: screen.width,
        screenHeight: screen.height
    };
}

export function deviceModel(userAgent: string | null | undefined): string {
    if (!userAgent) return 'Unknown';
    if (userAgent.includes('Windows')) return 'Windows PC';
    if (userAgent.includes('Macintosh')) return 'Mac';
    if (userAgent.includes('iPhone')) return 'iPhone';
    if (userAgent.includes('iPad')) return 'iPad';
    if (userAgent.includes('Android')) return 'Android Device';
    if (userAgent.includes('Linux')) return 'Linux PC';

    return 'Unknown';
}

export function osVersion(userAgent: string | null | undefined): string {
    if (!userAgent) return 'Unknown';
    if (userAgent.includes('Windows NT 10.0')) return 'Windows 10/11';
    if (userAgent.includes('Windows NT')) return 'Windows';

    const mac = userAgent.match(/Mac OS X ([^);]+)/);
    if (mac) return 'macOS ' + mac[1].replace(/_/g, '.');
    if (userAgent.includes('Mac OS X')) return 'macOS';

    const android = userAgent.match(/Android ([^);\s]+)/);
    if (android) return 'Android ' + android[1];
    if (userAgent.includes('Android')) return 'Android';
    if (userAgent.includes('Linux')) return 'Linux';

    return 'Unknown';
}
